<template>
    <modal
        v-if="isActive"
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="closeModal"
        :closeBtn="closeBtn"
        position="right"
        size='medium'
        id="catalog-root"
        class="catalog-panel loader-panel"
        classContent="overflow-hidden">
        <template v-slot:content>
            <div class="row">
                <div class="col">
                    <div class="title"> {{ title }}</div>
                    <hr/>
                </div>
            </div>
            <div class="panel-control d-flex flex-column flex-fill overflow-hidden">
                <div class="panel-control-content d-flex flex-column flex-fill overflow-hidden">
                    <template v-if="isEditMode">
                        <service-editor
                            :saving="saving"
                            :service="newService"
                            :services="services"
                            :serviceTypes="lists.serviceTypes"
                            :selectedService="selectedService"
                            @onChangeCatalogMode="onChangeCatalogMode"
                            @onAddService="onAddService"
                            @onDeleteService="onDeleteService"
                            :disabled="readonlyFormItem" />
                    </template>
                    <template v-else>
                        <div class="row d-flex flex-column flex-fill flex-nowrap overflow-hidden">
                            <div class="col-12">
                                <service-selector
                                    :services="services"
                                    :selectedService="selectedService"
                                    :isValidServiceSelected="isValidServiceSelected"
                                    :enableAddService="enableAddService"
                                    @onChangeSelectedService="onChangeSelectedService"
                                    @onChangeCatalogMode="onChangeCatalogMode"
                                    :disabled="readonlyFormItem || loading" />
                            </div>
                            <div class="col-12">
                                <MaterialInput
                                    :disabled="!selectedService || loading"
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-search"
                                    name="search"
                                    v-model.trim="form.search"
                                    v-validate="'min:3'"
                                    @input="onSearchTextChange"
                                    @keyEnter="onKeyEnter"
                                    :inputClasses="[{'is-invalid': fnHasError('search')}]"
                                    :error="fnFirstError('search')">
                                    Pesquise...
                                    <template v-slot:grpAppend>
                                        <button
                                            key="catalog_reset_button"
                                            v-if="includeResetButton"
                                            class="btn btn-light m-0 min-w-auto"
                                            :disabled="!selectedService || !form.search || loading"
                                            type="button"
                                            @click.prevent="reset">
                                            <i class="fas fa-times"></i>
                                        </button>
                                        <button
                                            key="catalog_search_button"
                                            v-if="includeSearchButton"
                                            data-toggle="tooltip-city"
                                            class="btn btn-main"
                                            :disabled="!selectedService || loading"
                                            type="button"
                                            @click.prevent="onKeyEnter">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </template>
                                </MaterialInput>
                            </div>
                            <div class="col-12 d-flex flex-column flex-fill overflow-hidden">
                                <template v-if="loading">
                                    <div class="catalog-results loading">
                                        <div class="">
                                            <div class="full-size-loader"></div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="loadingError" >
                                        <div class="alert alert-danger" role="alert">
                                            {{ errorMsg }}
                                        </div>
                                    </template>
                                    <template v-else-if="result && result.numberOfRecordsMatched === 0">
                                        <div>
                                            <div class="alert alert-primary" role="alert">
                                                No record matched
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="result">
                                        <div class="catalog-results flex-scroll">
                                            <record-grid
                                                key="records"
                                                :catalogURL="isValidServiceSelected && service.url || ''"
                                                :service="service"
                                                :crs="crs"
                                                :map="getMap()"
                                                :catalogType="service && service.type"
                                                :showTemplate="service && service.showTemplate"
                                                :defaultFormat="service && service.format"
                                                :formatOptions="service && service.url === service.url ? formatOptions : DEFAULT_FORMAT_WMS"
                                                :infoFormatOptions="service && service.url === service.url ? infoFormatOptions : getUniqueInfoFormats()"
                                                :records="records"
                                                :layerBaseConfig="layerBaseConfig"
                                                @onLayerAdd="onLayerAdd"
                                                @onError="onError"
                                            />
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!--
            <div class="panel-control flex-column flex-fill" :class="[isEditMode ? 'd-none' : 'd-flex' ]">
                <div class="panel-control-content d-flex flex-column flex-fill">

                </div>
            </div>
            -->
            <!--
            <div class="panel-control d-flex flex-column flex-fill" v-if="isEditMode">
                <div class="panel-control-content d-flex flex-column flex-fill">
                     <service-editor
                        :saving="saving"
                        :service="newService"
                        :services="services"
                        :serviceTypes="lists.serviceTypes"
                        :selectedService="selectedService"
                        @onChangeCatalogMode="onChangeCatalogMode"
                        @onAddService="onAddService"
                        @onDeleteService="onDeleteService"
                        :disabled="readonlyFormItem" />
                </div>
            </div>
            -->
        </template>
    </modal>
</template>

<script>
    import { isNil } from '@config/utils';
    import { mapGetters, mapActions } from "vuex";
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    export const DEFAULT_ALLOWED_PROVIDERS = ["OpenStreetMap", "OpenSeaMap", "Stamen"];
    import CatalogMixin from '../shared/catalog/CatalogMixin';
    import RecordGrid from '../shared/catalog/components/CatalogRecordGrid';
    import ServiceSelector from '../shared/catalog/components/CatalogServiceSelector';
    import ServiceEditor from '../shared/catalog/components/CatalogServiceEditor';
    import { DEFAULT_FORMAT_WMS } from "../shared/catalog/api/WMS";

    import SERVICES from '../shared/catalog/services';

    export default {
        name: "CatalogPanel",
        mixins: [
            ButtonControlMixin,
            CatalogMixin
        ],
        components: {
            Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
            RecordGrid,
            ServiceSelector,
            ServiceEditor,
        },
        props: {
            // title: {
            //     type: String,
            //     default: 'Catalogo'
            // },
            closeBtn: {
                type: Boolean,
                default: true
            },
            formatOptions: {
                type: Array,
                default: () => DEFAULT_FORMAT_WMS,
            },
            infoFormatOptions: {
                type: Array,
                default: () => [],
            },
            enableAddService: {
                type: Boolean,
                default: true
            },
            includeSearchButton: {
                type: Boolean,
                default: true
            },
            includeResetButton: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                idPanel: 'catalog',
                idPanelIdentify: 'identify',
                className: 'ol-catalog',
                showContent: false,
                lists: {
                    loaded: false,
                    serviceTypes: [
                        // { name: "csw", label: "CSW" },
                        { name: "wms", label: "WMS" },
                        { name: "wmts", label: "WMTS" },
                        // { name: "tms", label: "TMS", allowedProviders: DEFAULT_ALLOWED_PROVIDERS },
                        // { name: "wfs", label: "WFS" }
                    ],
                },
                servicesWithBackgrounds: {},
                form: {
                    search: null,
                },
                crs: "EPSG:3763",
            }
        },
        mounted() {

        },
        computed: {
            ...mapGetters({
                groupSelector: 'tocSelectedSelector',
                locales: 'currentLocaleSelector',
                loading: 'catalogLoadingSelector',
                saving: 'catalogSavingSelector',
                loadingError: 'catalogLoadingErrorSelector',
                services: 'catalogServicesSelector',
                service: 'catalogSelectedCatalogSelector',
                selectedService: 'catalogSelectedServiceSelector',
                selectedFormat : 'catalogSelectedServiceTypeSelector',
                options: 'catalogSearchOptionsSelector',
                layerOptions: 'catalogSelectedServiceLayerOptionsSelector',
                searchTextSelector: 'catalogSearchTextSelector',
                pageSize: 'catalogPageSizeSelector',
                result: 'catalogResultSelector',
                mode: 'catalogModeSelector',
                newService: 'catalogNewServiceSelector',
            }),
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            // [TODO] ENCONTRAR OUTRA FORMA PARA FORÇAR A FECHAR ESTE PAINEL
            isPanelIdentifyVisible(){
                return this.$store.getters[`${this.moduleCode}/isPanelVisible`](this.idPanelIdentify);
            },
            group() {
                return this.groupSelector(this.moduleCode);
            },
            searchText(){
                return this.searchTextSelector;
            },
            readonlyFormItem() {
                return false;
            },
            records() {
                if(!(this.result && this.result.records)){
                    return [];
                }
                let records = this.result && this.selectedFormat in SERVICES && SERVICES[this.selectedFormat].getCatalogRecords(
                        this.result,
                        { ...this.options, layerOptions: this.layerOptions, service: this.services },
                        this.locales
                        ) || [];

                // defaults for recordItem elements
                let metadataTemplate = "";
                let showTemplate = false;
                let hideThumbnail = false;

                if (this.service) {
                    const selectedService = this.service;
                    // check for configured metadata
                    if (!isNil(selectedService.metadataTemplate) &&
                        !isNil(selectedService.showTemplate)) {
                        showTemplate = selectedService.showTemplate;
                        metadataTemplate = selectedService.metadataTemplate;
                    }
                    // check for configured thumbnail
                    if (!isNil(selectedService.hideThumbnail)) {
                        hideThumbnail = selectedService.hideThumbnail;
                    }
                }
                let items = records.map((record) => showTemplate && metadataTemplate
                        ? { ...record, metadataTemplate }
                        : record);

                return items;
            },
            isValidServiceSelected() {
                return this.service !== undefined;
            },
            isEditMode() {
                return this.mode === "edit";
            },
            layerBaseConfig(){
                return {
                    group: this.group || undefined
                };
            },
            errorMsg() {
                let defaultError = 'Erro';
                return this.loadingError ?
                    (this.loadingError.error && this.loadingError.error.error ?
                        this.loadingError.error.error : (this.loadingError.error ? this.loadingError.error : defaultError)) : defaultError;
            },
        },
        methods: {
            ...mapActions([
                'setPanel',
            ]),
            initialize: function() {
                if(this.showContent){
                    return;
                }
                this.initCatalog();
                this.showContent=true;
                this.$nextTick(() => {
                    this.activeTooltip();
                });
            },
            closeModal: function() {
                this.onChangeCatalogMode('view', false, {onlyMode: true});
                this.closePanel();
            },
            addButtonMap: function(_map) {
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/layers.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.openPanel();
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            onKeyEnter(event) {
                this.search();
            },
            onSearch(params) {
                this.recordSearch(params);
            },
            onChangeText(text) {
                this.changeText(text);
            },
            onChangeSelectedService(val) {
                this.changeSelectedService(val);
            },
            onChangeCatalogMode(mode, isNew, params={}) {
                this.changeCatalogMode(mode, isNew, params)
            },
            onAddService(service) {
                this.addService(service)
            },
            onDeleteService(service) {
                this.deleteService(service)
            },
            onLayerAdd(layer, options){
                this.addLayerFromCatalogs(layer, options);
            },
            onError(error){
                this.showError(error, this.title);
            },
            onReset(){
                this.form.search=null;
            },
            onSearchTextChange(text){
                this.onChangeText(text);
            },
            search(start=1){
                const url = this.service.url;
                const type = this.service.type;
                let searchText = this.searchText;
                this.onSearch({
                    format: type,
                    url,
                    startPosition: start,
                    maxRecords: this.pageSize,
                    text: searchText || "",
                    options: {
                        service: this.service
                    }
                });
            },
            reset(){
                this.onReset();
            },
        },
        watch: {
            showModal: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.initialize();
                    }else{
                        this.hideTooltip();
                    }
                },
            },
            isPanelIdentifyVisible: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.closeModal();
                    }
                },
            },
            // service: {
            //     immediate: true,
            //     handler(value, oldVal) {
            //         console.log('service:', value);
            //         if(value && value.autoload){
            //             console.log('AUTOLOAD:', );
            //         }
            //     },
            // }
        },
    };
</script>

<style scoped lang="scss">
    .flex-scroll {
      overflow-y:scroll;
      min-height:0;
      -webkit-box-flex:1;
      flex:1;
    }

    .catalog-panel {

        .catalog-results {
            &.loading {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                > div {
                    overflow: 'hidden';
                    width: 176px;
                    height: 176px;
                }
            }
        }
    }


</style>